'use strict';

var BaseGroup = require('config/Group');
var i18n = require('i18next');
var RenderPositions = require('config/RenderPositions');

/**
 * "LAN Segregation" configuration group.
 */
module.exports = BaseGroup.extend({
  actionList: [
    {
      name: 'lanIsolationGlobal',
      position: RenderPositions.full,
      required: true,
      renderTitle: false,
      renderStatic: true,
    },
  ],

  /**
   * @return {Boolean}
   */
  isRequired: function() {
    return true;
  },

  /**
   * @return {String}
   */
  title: function() {
    return i18n.t('groups.lanIsolation');
  },
});
